import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { DenunciaService } from 'src/app/service/denuncia/denuncia.service';
import { ResponseHandler } from 'src/app/entity/ResponseHandlerDTO';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';
import { ERRO_DADOS_NAO_GRAVADOS, ERRO_DADOS_OBRIGATORIOS, ERRO_ASSUNTO_OBRIGATORIO } from 'src/app/tools/Mensagens';
import { DenunciaVO } from 'src/app/entity/DenunciaVO';
import { AbstractControl } from '@angular/forms';
import { URL, PAGINA_HOME_DENUNCIA_ANONIMA, PAGINA_SUCESSO_FORM, PAGINA_LOGIN} from 'src/app/tools/URL';


@Component({
  selector: 'denuncia-anonima-sucesso',
  templateUrl: './denuncia-anonima-sucesso.component.html',
  styleUrls: ['./denuncia-anonima-sucesso.component.css']
})
export class DenunciaAnonimaSucessoComponent implements OnInit {

  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;

  manifesto: any;
  urlDenuncia = URL.DENUNCIA;

  constructor(private service: DenunciaService, private router: Router) {
    this.manifesto = {
      id: '-'
    };
  }

  ngOnInit() {
    this.onSubmit();
  }

  onSubmit() {
    if (this.service.denuncia.value.assunto) {
      this.preencherDados();

      if (this.service.denuncia.valid) {
        this.service.enviarDenunciaAnonima(this.service.denuncia.value).
        //subscribe(retorno => {
          subscribe((responseHandler: ResponseHandler) => {
          //if (retorno) {
          if (responseHandler) {
            //alert(OK_MANIFESTO_ENVIADO);
            //this.router.navigate([PAGINA_SUCESSO_FORM]);
            this.manifesto.id = responseHandler.data.id;
            //alert(OK_PROTOCOLO_DENUNCIA_ANONIMA(this.manifesto.id));
            //this.router.navigate([DENUNCIA_ANONIMA_SUCESSO]);
          } else {
            alert(ERRO_DADOS_NAO_GRAVADOS);
          }
        });
      } else {
        const campos = this.tratarMensagemDeErro();
        alert(ERRO_DADOS_OBRIGATORIOS + campos);
      }
    } else {
      alert(ERRO_ASSUNTO_OBRIGATORIO);
    }
  }

  preencherDados() {
    //this.service.denuncia.controls.nome.setValue(this.authService.usuarioDTO.nome);
    //this.service.denuncia.controls.email.setValue(this.authService.usuarioDTO.email);
    this.service.denuncia.value.files = [];
    this.fileUploader.mapFilesBase64.forEach((value, key) => {
      this.service.denuncia.value.files.push({
        nomeArquivo: key,
        conteudo: value
      });
    });
  }

  tratarMensagemDeErro() {
    let campos: String[] = [];
    let construtor: any = DenunciaVO.prototype.constructor;
    Object.values(this.service.denuncia.controls).forEach((value: AbstractControl) => {
      if (!value.valid) {
        const formGroup = value.parent.controls;
        campos.push('\n' + construtor.descricaoAtributos[Object.keys(formGroup).find(name => value === formGroup[name])]);
      }
    });
    return campos;
  }

  homeDenunciaAnonima() {
    this.router.navigate([PAGINA_LOGIN], { queryParams: { url: this.urlDenuncia } });
  }




}
